<template>
  <DatatableReportV3
    id="customer-equipment-table"
    ref="datatable"
    title="All Customer Equipment"
    download-url="/reports/equipment"
    :config="config"
    :source="source"
    :filters="filters"
  />
</template>

<script>
import CONSTANTS from "@/Constants.js";
import EquipmentContextMenu from "@/Equipment/EquipmentContextMenu.vue";
import { fromNow } from "@/mixins";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "../vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    equipmentTypeFlag: {
      type: Boolean,
      default: false
    },
    warrantyFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      config: {
        order: [[12, "asc"]],
        columns: [
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "location_name", title: "Location Name" },
          {
            data: "address",
            class: "equipment-dt-address",
            filterName: "zipcode",
            orderable: false
          },
          {
            data: "membership_status",
            title: "Membership Status",
            orderData: 4,
            orderable: true,
            searchable: false
          },
          { data: "alpha_status", visible: false, searchable: false },
          {
            data: "equipment_name",
            title: "Equipment Name",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.equipment
          },
          {
            data: "install_location",
            title: "Location",
            orderable: true,
            searchable: false
          },
          {
            data: "manufacturer",
            filterName: "manufacturers"
          },
          {
            data: "equipment_type",
            title: "Equipment Type",
            filterName: "equipment_types",
            orderable: true,
            searchable: false
          },
          {
            data: "component_type",
            title: "Component Type",
            filterName: "component_types",
            orderable: true,
            searchable: false
          },
          { data: "model_number", title: "Model Number" },
          { data: "serial_number", title: "Serial Number" },
          {
            data: "manufacture_date",
            title: "Manufacture Date",
            orderable: true,
            searchable: false
          },
          {
            data: "installation_date",
            title: "Installation Date",
            filterName: "installed_on",
            orderable: true,
            searchable: false
          },
          {
            data: "last_service_date",
            title: "Last Service Date",
            orderable: true,
            searchable: false,
            visible: this.equipmentTypeFlag
          },
          {
            data: "age",
            title: "Age",
            filterName: "age_between",
            render: function (data) {
              if (!data || data === "--") {
                return "--";
              }
              return fromNow(new Date(data));
            }
          },
          {
            data: "warranty",
            title: "Included Warranty",
            searchable: false
          },
          {
            data: "extended_warranty",
            title: "Extended Warranty",
            filterName: "warranty_programs",
            visible: this.warrantyFlag
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            class: "equipment-dt-actions text-center",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "equipment-context-menu-vue",
            component: EquipmentContextMenu,
            options: {
              store,
              listeners: { "save-success": this.refreshData }
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "All Customer Equipment" });
  }
};
</script>

<style lang="scss">
.equipment-dt-actions {
  width: 50px;
  padding: 0;
  color: var(--lightblue) !important;
}
.equipment-dt-address {
  width: 200px;
}
#customer-equipment-table {
  overflow: visible;
  tr > td {
    vertical-align: baseline !important;
  }
}
</style>
